import type { FileUploader } from "@offstreetparking/design-system/forms/FileUpload";
import { offstreetClient } from "../../../../api/client";

export const usePrivateFileUploader = ({ companyId }: { companyId: number }): FileUploader => {
	const { mutateAsync: requestPrivateUpload } = offstreetClient.fileUploads.requestPrivateUpload.useMutation();
	const { mutateAsync: confirmUpload } = offstreetClient.fileUploads.confirmPublicUpload.useMutation();

	return {
		upload: async (file, progress) => {
			const { pendingFileId, presignedUrl } = await requestPrivateUpload({
				companyId,
				fileMime: file.type,
				fileName: file.name,
				fileSize: file.size,
			});

			await new Promise<void>((resolve, reject) => {
				const xhr = new XMLHttpRequest();
				xhr.open("PUT", presignedUrl, true);
				xhr.setRequestHeader("Content-Type", file.type);
				xhr.upload.onprogress = (event) => {
					if (event.lengthComputable) {
						progress(Math.round((event.loaded / event.total) * 95));
					}
				};
				xhr.onload = () => {
					if (xhr.status === 200) {
						resolve();
						return;
					}
					reject(new Error(`Upload failed with status ${xhr.status}`));
				};
				xhr.onerror = () => reject(new Error("Upload failed"));
				xhr.send(file);
			});

			await confirmUpload({ pendingFileId });
			progress(100);

			return {
				pendingFileId,
				url: URL.createObjectURL(file),
				name: file.name,
				size: file.size,
				key: String(pendingFileId),
				type: file.type,
				progress: 100,
			};
		},
	};
};
